import {
  API_ACCOUNT_ORDERS_URL,
  API_ACCOUNT_ORDER_URL,
  replacePlaceholders,
} from './urls';
import callWebApi from './callWebApi';
import { TRADE_SECURITY_PROCESSING, TRADE_SECURITY_COMPLETED } from '.';
import { ORDER_CANCELED } from './investment';


/**
 * Create a buy or sell order in the current account
 *
 * @example
 * // Create a buy order: 10 shares of APPL
 * const orderId = await dispatch(createOrder('BUY', 'AAPL', 10));
 *
 * // Create a sell order: 3 shares of APPL if price is under 100 with the order
 * // in effect (term) until fulfilled or canceled by user
 * const orderId = await dispatch(createOrder('SELL', 'AAPL', 3, { limitPrice: 100, term: 'GTC' }));
 *
 * @returns {Promise} that resolves to the new order's id
 */
export const createOrder = (
  side,
  ticker,
  requestedShareAmount,
  {
    limitPrice,
    stopPrice,
    term, // 'DAY' or 'GTC'
  } = {},
) => async (dispatch, getState) => {
  const { authToken, currentAccount } = getState();
  dispatch({ type: TRADE_SECURITY_PROCESSING });
  const url = replacePlaceholders(API_ACCOUNT_ORDERS_URL, {
    accountNumber: currentAccount,
  });
  const orderParams = {
    side,
    ticker,
    requestedShareAmount,
    ...{
      limitPrice,
      stopPrice,
      term,
    },
  };
  const res = await callWebApi('POST', url, orderParams, authToken);
  dispatch({ type: TRADE_SECURITY_COMPLETED, orderId: res.orderId, orderDate: res.orderDate });
  return res.orderId;
};


/**
 * Cancel an order in the current account
 *
 * @example
 * await dispatch(cancelOrder('SOME_ORDER_ID'));
 *
 * @returns {Promise} that resolves to nothing
 */
export const cancelOrder = (orderId, orderType) => (dispatch, getState) => {
  const { authToken, currentAccount } = getState();
  const url = replacePlaceholders(API_ACCOUNT_ORDER_URL, {
    accountNumber: currentAccount,
    orderId,
  });
  dispatch({ type: ORDER_CANCELED, orderType, id: orderId });
  return callWebApi('DELETE', url, undefined, authToken);
};



// WEBPACK FOOTER //
// ./src/actions/orders.js